import { AuthLayout } from '@ui/components/layouts';
import { useConvexAuth } from 'convex/react';
import { useNavigate } from 'react-router-dom';
import { type ReactNode, useEffect } from 'react';
import { toast } from 'sonner';

import { PageContentLoading } from '@/src/components/PageContentLoading';
import { webAppRoutes } from '@/src/lib/navigation/containerPaths';

export interface AuthPublicPageHandlers {
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
  onSuccessNavigate: () => void;
  navigate: (path: string) => void;
}

interface AuthPublicPageContainerProps {
  children: (handlers: AuthPublicPageHandlers) => ReactNode;
}

export function AuthPublicPageContainer({ children }: AuthPublicPageContainerProps) {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useConvexAuth();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate(webAppRoutes.home, { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading || isAuthenticated) {
    return (
      <AuthLayout>
        <PageContentLoading />
      </AuthLayout>
    );
  }

  return children({
    onSuccess: (message) => toast.success(message),
    onError: (message) => toast.error(message),
    onSuccessNavigate: () => navigate(webAppRoutes.home, { replace: true }),
    navigate: (path) => navigate(path),
  });
}
